import { useState, useEffect } from 'react';
import axios from 'axios';

const useETHPrice = () => {
  const [ethPrice, setEthPrice] = useState(null);
  const [getloading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
     const fetchEthPrice = async () => {
       try {
         // Fetch ETH price from CryptoCompare API
         const response = await fetch(
           "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD,EUR,CNY,JPY,GBP"
         );
 
         if (!response.ok) {
           throw new Error(`HTTP error! status: ${response.status}`);
         }
 
         const data = await response.json();
 
         // Extract ETH price in USD
         setEthPrice(data.USD);
       } catch (err) {
         console.error("Error fetching ETH price:", err);
         setError("Failed to fetch ETH price");
       } finally {
         setLoading(false);
       }
     };
 
     fetchEthPrice();
   }, []);
  return { ethPrice, getloading, error };
};

export default useETHPrice;
